export const CALCULATE_SAVINGS = 'CALCULATE_SAVINGS';
export const calculateSavings = calculatorFormData => {
  return {
    type: CALCULATE_SAVINGS,
    calculatorFormData,
  };
};



// WEBPACK FOOTER //
// ./app/javascript/apps/calculator/actions.js